export const GRID = {
  defaultSize: 20,
  minSize: 5,
  maxSize: 100,
};

export const FONT_FAMILIES = {
  ui: '"Inter", "DM Sans", sans-serif',
  uiSvg: "Inter, 'DM Sans', sans-serif",
  connector: '"DM Sans", sans-serif',
  connectorSvg: "'DM Sans', sans-serif",
};

export const LINE_HEIGHT_RATIO = 1.3;

export const PADDING = {
  shapeText: 12,
  textElement: 8,
  export: 20,
  connectorLabel: 4,
  drawingExport: 50,
};

export const COLORS = {
  white: '#ffffff',
  black: '#000000',
  ink: '#1a1a1a',
  accent: '#2563eb',
  accentLight: '#60a5fa',
  /** Softer selection color for text bounding boxes (Excalidraw-style) */
  textSelection: '#6965db',
  textSelectionLight: '#a8a5ff',
  connectorLabelDark: '#1a1a1f',
  connectorLabelLight: '#ffffff',
  selectionArcFill: '#fef3c7',
  selectionArcStroke: '#d97706',
};

export const GRID_COLORS = {
  lineLight: 'rgba(255, 255, 255, 0.08)',
  lineDark: 'rgba(0, 0, 0, 0.05)',
  axisLight: 'rgba(255, 255, 255, 0.15)',
  axisDark: 'rgba(0, 0, 0, 0.1)',
};

export const INVERT_COLOR_MAP: Record<string, string> = {
  '#ffffff': '#2a2a2f',
  '#2a2a2f': '#ffffff',
  '#374151': '#e5e5e5',
  '#e5e5e5': '#374151',
  '#1a1a1a': '#e5e5e5',
  '#000000': '#ffffff',
  black: '#ffffff',
};

export const SHAPE = {
  handleThreshold: 12,
  minSize: 20,
  handleSize: 8,
};

export const CONNECTOR = {
  arrowSize: 10,
  placementOffset: 40,
  hitTestThreshold: 10,
};

export const TEXT = {
  minFontSize: 5,
};

export const ANIMATION = {
  toolbarTransition: 150,
  modalFade: 200,
};

export const CLIPBOARD = {
  pasteOffset: 20,
};
